<template>
    <section class="list-thematiques">
        <div class="wrapper">
            <div class="filtres">
                <a v-for="filtre in filtres"
                   class="btn"
                   @click="updateHash(filtre.slug)"
                   :class="{ outline: isActive(filtre.slug) }"
                   v-if="!isMobile"
                >
                    {{filtre.name}}
                </a>

                <custom-select
                        valueField="slug"
                        labelField="name"
                        v-model="customSelectValue"
                        :options="filtres"
                        v-on:change="updateHash($event)"
                        v-if="isMobile"
                ></custom-select>

            </div>

            <transition-group name="list" appear tag="div" class="list-wrap">
                <thematique-card
                        v-for="(thematique, index) in filteredThematique"

                        v-if="showCard(index, thematique)"
                        :thematique=thematique
                        :key="index"
                        :class="thematique.slug"
                >
                </thematique-card>
            </transition-group>
            <a class="btn chevron dir-down loadmore"
               @click="showMore()"
               v-if="!reachEnd"
            >Charger plus de thématiques</a>

        </div>

    </section>
</template>

<script>
    import $ from 'jquery';
    import Scrolling from '../../libs/Scrolling';

    export default {
        props: {
            filtres: {
                type: Array,
                required: true,
            },
            thematiques: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                filtreSlugSelected: 'all',
                themeShowLimit: null,
                defautThemeShowLimit: 2,
                filteredThematique: [],
                filtresSlug: [],
                firstClick: true,
                customSelectValue: this.filtres[0].slug,

            };
        },
        computed: {
            reachEnd() {
                if (this.filteredThematique.length === this.themeShowLimit || this.filteredThematique.length < this.themeShowLimit) {
                    return true;
                } else {
                    return false;
                }
            },
            isMobile() {
                return this.$root.isMobile;
            }

        },
        methods: {
            scrollFirstClick() {
                if (this.firstClick) {
                    Scrolling.scrollTo('.filtres', 'easeInOutQuint', 1200, 80);
                    this.firstClick = false;
                }
            },
            changeFilter(selectedFilter) {

                this.filteredThematique = [];
                this.themeShowLimit = this.defautThemeShowLimit;
                setTimeout(() => {

                    this.filtreSlugSelected = selectedFilter;

                    this.filteredThematique = this.thematiques.filter((theme) => {
                        if (this.filtreSlugSelected === 'all') {
                            return theme;
                        } else {
                            return theme.parent.slug === this.filtreSlugSelected;
                        }
                    });


                }, 100);
            },
            updateHash: function (selectedFilter) {
                location.hash = 'filter=' + encodeURIComponent(selectedFilter);
            },
            getHashFilter: function () {
                // get filter=filterName
                var matches = location.hash.match(/filter=([^&]+)/i);
                var hashFilter = matches && matches[1];
                if (hashFilter === null || this.filtresSlug.indexOf(hashFilter) == -1) {
                    hashFilter = 'all';
                }
                return hashFilter && decodeURIComponent(hashFilter);
            },
            isActive(slug) {
                if (this.filtreSlugSelected === slug) {
                    return false;
                }
                else {
                    return true;
                }
            },
            showCard(index, thematique) {

                if (index < this.themeShowLimit && this.filtreSlugSelected === 'all') {
                    return true;
                } else if (index < this.themeShowLimit && this.filtreSlugSelected === thematique.parent.slug) {
                    return true;
                } else {
                    return false;
                }
            },
            showMore() {
                let cible = 'article.' + this.filteredThematique[this.themeShowLimit].slug;
                this.themeShowLimit++;
                setTimeout(() => {
                    Scrolling.scrollTo(cible, 'easeInOutQuint', 1200, 80);
                }, 10);

            },
            SlugFromHome(slug) {

                this.thematiques.map((theme) => {

                    if (theme.slug === slug) {

                        this.changeFilter(theme.parent.slug);
                        let cible = 'article.' + theme.slug;
                        this.themeShowLimit = 999;
                        this.customSelectValue = theme.parent.slug;
                        setTimeout(() => {
                            Scrolling.scrollTo(cible, 'easeInOutQuint', 1000, 40);
                        }, 800);

                    }

                });
            }


        },
        created() {
            this.themeShowLimit = this.defautThemeShowLimit;
            this.filteredThematique = this.thematiques;

            // Get slugs filter in a array for indexOf
            this.filtres.forEach((element) => {
                this.filtresSlug.push(element.slug);
            });

            if (!this.$route.hash.includes("#filter")) {
                this.SlugFromHome(this.$route.hash.substring(1));
            } else {
                var hashFilter = this.getHashFilter();
                this.changeFilter(hashFilter);
                this.customSelectValue = hashFilter;
            }


            $(window).on('hashchange', () => {

                var hashFilter = this.getHashFilter();
                this.changeFilter(hashFilter);
            });


        },

    };
</script>
<!--todo Soucis de prop avoid mutating sur le custom select-->


// WEBPACK FOOTER //
// assets/js/components/taxonomy-thematique/ThematiqueList.vue